import { render } from "./p-select.vue?vue&type=template&id=453ce889&scoped=true"
import script from "./p-select.vue?vue&type=script&lang=js"
export * from "./p-select.vue?vue&type=script&lang=js"

import "./p-select.vue?vue&type=style&index=0&id=453ce889&scoped=true&lang=scss"
import "./p-select.vue?vue&type=style&index=1&id=453ce889&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453ce889"],['__file',"src/components/p-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453ce889"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453ce889', __exports__)) {
    api.reload('453ce889', __exports__)
  }
  
  module.hot.accept("./p-select.vue?vue&type=template&id=453ce889&scoped=true", () => {
    api.rerender('453ce889', render)
  })

}


export default __exports__